import {
  ARBleAzoteFrequency,
  ARBleAzotePeriod,
  ARBleAzoteProductType,
  ARBleCIDestructionPeriod,
  ARBleCIDevelopment,
  ARBleCIType,
  ARBleEtatVegetatifSh,
  ARBleOrderType,
  ARBlePastResiduType,
  ARBlePrairieAge,
  ARBlePrairieDestructionPeriod,
  ARBlePrairieExploitationMode,
  ARBlePrairiePostDestructionRank,
  ARBlePrairieType,
  ARVerseApportMoAutomne,
  ARVerseApportsMinerauxFractionnement,
} from './agrorendement-ble-lists.model';
import {
  ARConsoleFormatType,
  ARConsoleModulationType,
  ARConsoleType,
  ARConsoleVersion,
  ARFertilizerType,
} from './agrorendement-common-lists.model';
import { Campaign } from './campaign.model';
import { Parcel } from './parcel.model';

export class ARBleCampaign extends Campaign {
  configuration: ARBleCampaignConfiguration;
}

export class ARBleCampaignConfiguration {
  id: number;

  startingOn: string | Date;
  orderT1EndingOn: string | Date;
  dataT1EndingOn: string | Date;
  orderT2EndingOn: string | Date;
  dataT2EndingOn: string | Date;
  dataT3StartingOn: string | Date;
  orderT3EndingOn: string | Date;
  dataT3EndingOn: string | Date;

  createdAt: string | Date;
  updatedAt: string | Date;

  campaign: ARBleCampaign;
}

export class ARBleOrder {
  id: number;
  campaign: ARBleCampaign;
  orderItems: ARBleOrderItem[];

  createdAt: string | Date;
  updatedAt: string | Date;
}

export class ARBleOrderItem {
  id: number = null;

  t1Completed: boolean = null;
  t2Completed: boolean = null;
  t3Completed: boolean = null;
  dnCompleted: boolean = null;
  agrofertCompleted: boolean = null;
  verseCompleted: boolean = null;

  objective: number = null;

  orderType: ARBleOrderType = null;

  public get hasT1() {
    return this.orderType && ['T1_T2_2N_T3', 'T1_T2_2N', 'T1_T2_T3@3N', 'T1_T2_T3@DFE'].includes(this.orderType.code);
  }

  public get hasT2() {
    return (
      this.orderType &&
      ['T1_T2_2N_T3', 'T1_T2_2N', 'T1_T2_T3@3N', 'T1_T2_T3@DFE', 'T2_2N', 'T2_T3@3N', 'T2_T3@DFE'].includes(
        this.orderType.code,
      )
    );
  }

  public get hasDn() {
    return this.orderType && ['T1_T2_2N_T3', 'T1_T2_2N', 'T2_2N', '2N', '2N_SIMP'].includes(this.orderType.code);
  }

  public get hasT3() {
    return (
      this.orderType &&
      [
        'T1_T2_2N_T3',
        'T1_T2_T3@3N',
        'T1_T2_T3@DFE',
        'T2_T3@3N',
        'T2_T3@DFE',
        'T3@3N',
        'T3@DFE',
        'T3@3N_SIMP',
        'T3@DFE_SIMP',
      ].includes(this.orderType.code)
    );
  }

  public get hasT3Tn() {
    return this.orderType && ['T1_T2_T3@3N', 'T2_T3@3N', 'T3@3N', 'T3@3N_SIMP'].includes(this.orderType.code);
  }

  public get hasT3Dfe() {
    return (
      this.orderType &&
      ['T1_T2_2N_T3', 'T1_T2_T3@DFE', 'T2_T3@DFE', 'T3@DFE', 'T3@DFE_SIMP'].includes(this.orderType.code)
    );
  }

  public get hasZonage() {
    // on liste les orderTypes qui n'ont pas de zonage
    return this.orderType && !['2N_SIMP', 'T3@3N_SIMP', 'T3@DFE_SIMP'].includes(this.orderType.code);
  }

  needsVerse: boolean = null;
  needsAgrofert: boolean = false;
  userProvidedAzote: number = null;

  t1AzoteToSpread: number = null;
  t1FertilizerType: ARFertilizerType = null;
  t1FertilizerConcentration: number = null;

  t1ConsoleModulationType: ARConsoleModulationType = null;
  t1ConsoleType: ARConsoleType = null;
  t1ConsoleVersion: ARConsoleVersion = null;
  t1OtherConsoleVersion: string = null;
  t1ConsoleFormatType: ARConsoleFormatType = null;

  t2AzoteToSpread: number = null;
  t2FertilizerType: ARFertilizerType = null;
  t2FertilizerConcentration: number = null;

  t2ConsoleModulationType: ARConsoleModulationType = null;
  t2ConsoleType: ARConsoleType = null;
  t2ConsoleVersion: ARConsoleVersion = null;
  t2OtherConsoleVersion: string = null;
  t2ConsoleFormatType: ARConsoleFormatType = null;

  dnFertilizerType: ARFertilizerType = null;
  dnFertilizerConcentration: number = null;
  dnConsoleModulationType: ARConsoleModulationType = null;
  dnConsoleType: ARConsoleType = null;
  dnConsoleVersion: ARConsoleVersion = null;
  dnOtherConsoleVersion: string = null;
  dnConsoleFormatType: ARConsoleFormatType = null;

  t3AzoteAlreadySpread: number = null;
  t3FertilizerType: ARFertilizerType = null;
  t3FertilizerConcentration: number = null;
  t3LastAzoteAlreadySpread: number = null;
  t3LastAzoteAlreadySpreadDate: string | Date = null;

  t3ConsoleModulationType: ARConsoleModulationType = null;
  t3ConsoleType: ARConsoleType = null;
  t3ConsoleVersion: ARConsoleVersion = null;
  t3OtherConsoleVersion: string = null;
  t3ConsoleFormatType: ARConsoleFormatType = null;

  // verse
  pastAzoteFrequency: ARBleAzoteFrequency = null;
  verseApportMoAutomne: ARVerseApportMoAutomne = null;
  verseApportsMinerauxFractionnement: ARVerseApportsMinerauxFractionnement = null;

  // TODO PPF : suppr
  etatVegetatifSh: ARBleEtatVegetatifSh = null;

  hasReliquatSh: boolean = null;
  reliquatSh: number = null;

  firstAzoteProductType: ARBleAzoteProductType = null;
  firstAzotePeriod: ARBleAzotePeriod = null;
  firstAzoteConcentration: number = null;
  firstAzoteDensity: number = null;

  secondAzoteProductType: ARBleAzoteProductType = null;
  secondAzotePeriod: ARBleAzotePeriod = null;
  secondAzoteConcentration: number = null;
  secondAzoteDensity: number = null;

  pastAzoteProductType: ARBleAzoteProductType = null;

  hasPastAzotePreviousCulture: boolean = null;
  pastAzotePreviousCultureProductType: ARBleAzoteProductType = null;
  pastAzotePreviousCultureConcentration: number = null;
  pastAzotePreviousCultureDensity: number = null;

  pastResiduType: ARBlePastResiduType = null;

  hasPrairie: boolean = null;
  prairieAge: ARBlePrairieAge = null;
  prairieDestructionPeriod: ARBlePrairieDestructionPeriod = null;
  prairiePostDestructionRank: ARBlePrairiePostDestructionRank = null;
  prairieExploitationMode: ARBlePrairieExploitationMode = null;
  prairieType: ARBlePrairieType = null;

  hasCi: boolean = null;
  ciType: ARBleCIType = null;
  ciDevelopment: ARBleCIDevelopment = null;
  ciDestructionPeriod: ARBleCIDestructionPeriod = null;
  isCiEvery2Years: boolean = null;
  //fin PPF

  order: ARBleOrder = null;
  parcel: ARBleParcel = null;

  createdAt: string | Date = null;
  updatedAt: string | Date = null;

  //dates planning
  t1_date_livraison: Date = null;
  t2_date_livraison: Date = null;
  t3_date_livraison: Date = null;
  dn_date_livraison: Date = null;

  suspendedT1: boolean = false;
  suspendedT2: boolean = false;
  suspendedT3: boolean = false;
  suspendedDn: boolean = false;

  defaultWeekT1: Date = null;
  defaultWeekT2: Date = null;
  defaultWeekT3: Date = null;
  defaultWeekDn: Date = null;
}

export class ARBleParcel extends Parcel {
  orderItem: ARBleOrderItem;
}
